(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6284],{

/***/ 60052:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/redirect",
      function () {
        return __webpack_require__(27754);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 27754:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ RedirectPage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24826);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(84423);
/* harmony import */ var _integrations_tracking_posthog_posthogTracker__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57714);





var __N_SSG = true;
function RedirectPage() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)("common").t;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (!router.isReady) return;
        var _query = router.query, to = _query.to, from = _query.from;
        if (!to) return;
        // UTM params are auto-captured by PostHog $pageview from the URL
        // Custom event adds destination + origin for funnel analysis
        _integrations_tracking_posthog_posthogTracker__WEBPACK_IMPORTED_MODULE_4__/* .posthogTracker.sendEvent */ .g.sendEvent({
            category: "redirect",
            object: "external",
            action: "initiated",
            data: {
                to: to,
                from: from !== null && from !== void 0 ? from : ""
            }
        });
        // 300ms to allow PostHog to flush before navigating away
        setTimeout(function() {
            window.location.href = to;
        }, 300);
    }, [
        router.isReady,
        router.query
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        style: {
            minHeight: "100vh",
            background: "#fff",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: 16
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("style", {
                children: "\n        @keyframes spin { to { transform: rotate(360deg); } }\n      "
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                style: {
                    width: 40,
                    height: 40,
                    border: "3px solid #e5e7eb",
                    borderTopColor: "#6b7280",
                    borderRadius: "50%",
                    animation: "spin 0.8s linear infinite"
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                style: {
                    margin: 0,
                    color: "#6b7280",
                    fontSize: 16
                },
                children: t("isRedirecting")
            })
        ]
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(60052); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);